export const requiredFields =
    process.env.REACT_APP_COMMERCIAL_CRM_FIELDS_BASE_BP?.split(',') || [
        'Nombre',
        'Cedula',
        'Celular',
        'Tipo de Base',
        'Fecha Real',
        'Linea de Credito',
        'Prioridad',
        'Asesor',
    ];
